export default __webpack_public_path__ + "static/media/GR00030-disciple_medal_6.d402e93c.svg";